export interface IActivityFilter24hValue {
  minVolume24h?: number;
  minPriceChange24h?: number;
  maxPriceChange24h?: number;
}

export const PRICE_CHANGE_PRESETS = [
  { label: "+5%+", value: 5 },
  { label: "+10%+", value: 10 },
  { label: "-5%+", value: -5 },
];

export const VOLUME_24H_TOOLTIP_TEXT =
  "Total traded volume in the last 24 hours.";

export const PRICE_CHANGE_24H_TOOLTIP_TEXT =
  "Percentage change in price over the last 24 hours.";
